import React from 'react';
import styles from './Form.module.scss';
import ApeButton from '../Button/Button';

function Form(props: FormProps) {
  const { isDisabled, className, style, testId } = props;
  return (
    <form className={`${styles.formContainer} ${className}`} style={style} data-testid={testId}>
        {props.children}
        <ApeButton isDisabled={isDisabled} onClick={props.onAction} actionLabel={props.actionLabel}></ApeButton>
    </form>
  );
}

export default Form;
